<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<QueryCondition @query="query" @exportExcel="exportExcel" :showEvent="false" ref="queryCondition" />
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
	</div>
</template>

<script>
	import api from '../../../api'
	import QueryCondition from '../../../components/statistics/QueryCondition4'
	import TableFuncs from '../../../components/statistics/TableFuncs'
	import { LINK_TYPES } from '../../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				queryParams: {
					appId: '',
					startDate: null,
					endDate: null,
					pageName: '',
				},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '日期',
						key: 'createDay',
						align: 'center'
					},
					{
						title: '一级分类',
						key: 'pageName',
						align: 'center'
					},
					{
						title: '点击',
						key: 'totalNum',
						align: 'center',
					}
				]
			}
		},
		created() {
			//this.getData();
		},
		methods: {
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				if (!params.appId) {
					this.$Message.warning('请选择app')
					return
				}
				if (!params.dateRange) {
					params.dateRange = []
				}
				this.queryParams = {
					appKey: params.appId,
					startDate: params.dateRange[0] || null,
					endDate: params.dateRange[1] || null,
					pageName: params.pageName,
				}
				this.refreshData()
			},
			exportExcel(params) {
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					appKey: params.appId,
					startDate: params.dateRange[0] || null,
					endDate: params.dateRange[1] || null,
					pageName: params.pageName,
				}
				api.statistics
					.exportPage(queryParams)
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.getPageData(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},

		},



	}
</script>
